export { default } from './CapcaleraCercador';
